export const DB_RESPONSE_OK = 100 as const;
export const DB_RESPONSE_ERROR = 200 as const;
